var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepsdemo-content"},[_c('i',{staticClass:"pi pi-fw pi-ticket"}),_c('p',[_vm._v("Seat Component Content via Child Route")])])
}]

export { render, staticRenderFns }